var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "Signature_Control"
  }, [_c("div", {
    staticClass: "box_nav"
  }, [_c("div", {
    staticStyle: {
      display: "flex",
      "align-items": "center"
    }
  }, [_c("a-upload", {
    attrs: {
      "list-type": "picture-card",
      action: _vm.action,
      "max-count": _vm.formDataArray.fileNumber.value,
      "before-upload": _vm.beforeUpload,
      multiple: _vm.formDataArray.fileNumber.is_many,
      data: {
        module: "auditAttachment"
      },
      showUploadList: {
        showPreviewIcon: true,
        showRemoveIcon: true
      },
      headers: {
        "X-Dispatch": "Upload",
        "X-Version": "upload"
      }
    },
    on: {
      change: _vm.changeUpload
    }
  }, [_c("div", {
    staticClass: "upload-icon"
  }, [_c("div", {
    on: {
      click: function ($event) {
        return _vm.clickPlusTWO();
      }
    }
  }, [_c("a-icon", {
    attrs: {
      type: "plus"
    }
  }), _c("div", {
    staticClass: "ant-upload-text"
  }, [_vm._v(_vm._s(_vm.$t("上传")))])], 1)])])], 1), _c("div", {
    staticClass: "nameBox"
  }, [_c("div", {
    staticClass: "pictureBox"
  }, [_c("div", [_vm.formDataArray.fileFormat.length != 0 ? _c("span", [_vm._v(" *" + _vm._s(_vm.$t("文件格式")) + "（" + _vm._s(_vm.formDataArray.fileFormat.join(",")) + "） ")]) : _vm._e(), _vm.formDataArray.fileListData.length != 0 ? _c("span", {
    staticStyle: {
      color: "#1890ff",
      cursor: "pointer"
    },
    on: {
      click: _vm.openModal
    }
  }, [_vm._v(_vm._s(_vm.$t("模板预览")))]) : _vm._e()]), _c("div", {
    staticClass: "nav_qain"
  }, [_vm._v(" " + _vm._s(_vm.$t(_vm.formDataArray.promptText)) + " ")]), _c("a-modal", {
    attrs: {
      visible: _vm.isModalVisible,
      title: _vm.$t("文件列表"),
      width: 400,
      "body-style": {
        height: "300px"
      },
      footer: null
    },
    on: {
      change: _vm.closeModal
    }
  }, [_c("div", {
    staticStyle: {
      display: "flex"
    }
  }, _vm._l(_vm.formDataArray.fileListData, function (file) {
    return _c("a-tooltip", {
      key: file.name,
      attrs: {
        placement: "topLeft",
        title: file.name
      }
    }, [_c("a-upload", {
      staticClass: "upload_delet",
      attrs: {
        showRemoveIcon: false,
        "file-list": [file],
        "list-type": "picture-card"
      }
    })], 1);
  }), 1)])], 1)])])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };